'use strict';

angular.module('posApp').filter('noHTML', () => (text) => {
  if (text) {
    return text
      .replace(/&/g, '&amp;')
      .replace(/>/g, '&gt;')
      .replace(/</g, '&lt;');
  } else {
    return '';
  }
});
